import { useCallback, useState } from 'react'

export const useInformation = () => {
  const [modalOpen, setModalOpen] = useState(false)

  const handleRegisterOptionClick = useCallback(url => {
    window.location.href = url
  }, [])

  const handleOpenModal = useCallback(() => setModalOpen(true), [])

  const handleCloseModal = useCallback(() => () => setModalOpen(false), [])

  return {
    modalOpen,
    handleRegisterOptionClick,
    handleOpenModal,
    handleCloseModal,
  }
}
